module.exports = __webpack_public_path__ + "4d50a83a8394120b7dfbf2ad731efa8c.jpg";